import { useParams } from 'react-router-dom';
import StaffMemberJobComponent from './StaffMemberJob.component';
import { useStaffMemberInfoContext } from '../StaffMemberInfo/StaffMemberInfo.context';

const StaffMemberJob = (): JSX.Element => {
  const { id = '' } = useParams();
  const { staffMember, refreshUser } = useStaffMemberInfoContext();

  return (
    <StaffMemberJobComponent
      staffMemberId={id}
      staffMember={staffMember}
      onUpdateStaffMember={refreshUser}
    />
  );
};

export default StaffMemberJob;
